export const MuiFormHelperText = (palette) => ({
  styleOverrides: {
    root: {
      marginTop: '4px',
      fontFamily: "'Roboto', sans-serif",
      fontWeight: 400,
      fontSize: '14px',
      lineHeight: '20px',
      color: palette.neutral[500],
      letterSpacing: 0,
    },
  },
});
